var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearchResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.568,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_x2C__magnifier_x2C__magnifying_x2C__emoji_x2C__No_results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1857_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1791_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z ",
    fill: "#263238",
    id: "XMLID_1797_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "#263238",
    id: "XMLID_1794_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1764_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4103_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4109_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.43,
    x2: 21.214,
    y1: 23.401,
    y2: 21.186
  }), /*#__PURE__*/React.createElement("path", {
    d: " M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z",
    fill: "none",
    id: "XMLID_4108_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    fill: "none",
    id: "XMLID_4107_",
    r: 11.5,
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M12,15.521c0-0.55,0.45-1,1-1s1,0.45,1,1",
    fill: "none",
    id: "XMLID_4106_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z",
    fill: "none",
    id: "XMLID_4105_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "none",
    id: "XMLID_4104_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4096_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_4102_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.43,
    x2: 21.214,
    y1: 23.401,
    y2: 21.186
  }), /*#__PURE__*/React.createElement("path", {
    d: " M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z",
    fill: "none",
    id: "XMLID_4101_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    fill: "none",
    id: "XMLID_4100_",
    r: 11.5,
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M12,15.521c0-0.55,0.45-1,1-1s1,0.45,1,1",
    fill: "none",
    id: "XMLID_4099_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z",
    fill: "none",
    id: "XMLID_4098_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: " M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z",
    fill: "none",
    id: "XMLID_4097_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResultsIcon);
export default __webpack_public_path__ + "static/media/no-search-results-icon.ab673fb4c5bbdb329edfe349fdcf209c.svg";
export { ForwardRef as ReactComponent };